import { Divider, Typography } from "@mui/material";

interface HeaderDividerProps {
    title: string
};

const HeaderDivider = (props: HeaderDividerProps) => {
    return (
        <Divider component="div" role="presentation">
            <Typography variant="h5" sx={{ marginTop: 3, marginBottom: 2 }}>
                {props.title}
            </Typography>
        </Divider>
    );
};

export default HeaderDivider;